subscription TravelAuthorizationReportPreviewStatus($id: UUID!) {
  travelAuthorizationReportPreviewStatus(id: $id) {
    document {
      id
      _downloadLink
    }
    status
  }
}
